import { Link } from "react-router-dom";
import { MonoLabel, Em, Card } from "@/site/components/Atoms";
import { INSIGHTS } from "@/site/pages/insightsContent";

export default function Insights() {
  return (
    <>
      <section className="max-w-[1500px] mx-auto px-6 lg:px-10 pt-16 lg:pt-20">
        <div className="fade-up">
          <MonoLabel>INSIGHTS</MonoLabel>
        </div>
        <h1 className="h-display fade-up delay-1 mt-6 text-[44px] sm:text-[58px] lg:text-[68px] max-w-4xl">
          Strategic perspectives on <Em>opportunity development.</Em>
        </h1>

        <div className="fade-up delay-2 mt-8 max-w-2xl space-y-5 text-[14px] leading-[1.85] text-white/65">
          <p>
            Forealco Insights provides strategic perspectives on market entry, Kosovo's opportunity
            landscape, trade routes, institutional environments, defense-related support
            ecosystems, digital transformation, and structured business development.
          </p>
          <p>
            These articles are not generic country summaries. Each note is designed to examine how
            a market opportunity can be assessed, localized, structured, and transformed into an
            operational business route.
          </p>
          <p>
            The focus is practical: tax positioning, trade access, company formation, institutional
            programs, defense and support services, digital products, local partnerships, and
            cross-border execution.
          </p>
        </div>
      </section>

      <section className="max-w-[1500px] mx-auto px-6 lg:px-10 mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {INSIGHTS.map(({ n, slug, title, dek }) => (
          <Link
            key={n}
            to={`/insights/${slug}`}
            data-testid={`insight-card-${n}`}
            className="block"
          >
            <Card className="p-7 h-full group cursor-pointer relative overflow-hidden">
              <div
                className="absolute inset-x-0 top-0 h-px transition-all duration-500"
                style={{
                  background:
                    "linear-gradient(90deg, transparent, #9DB4FF 50%, transparent)",
                  opacity: 0.5,
                }}
              />
              <MonoLabel>NOTE · {n}</MonoLabel>
              <div className="mt-5 font-display text-[22px] leading-[1.25]">{title}</div>
              <p className="mt-4 text-[13px] leading-[1.75] text-white/60">{dek}</p>
              <div className="mt-7 text-[10px] tracking-[0.3em] uppercase text-[#9DB4FF] opacity-80 group-hover:opacity-100 transition-opacity">
                Read insight →
              </div>
            </Card>
          </Link>
        ))}
      </section>
    </>
  );
}
